import { atom } from "jotai";
import { AxiosInstance } from "axios";
import { ApiTaskMinimal } from "src/api/types";
import useApi, {
	ApiActions,
	ApiFilter,
	ApiStatus,
	emptyApiState,
	Pagination,
} from "src/hooks/api/utils/useApi";
import useAuth from "src/hooks/selectors/useAuth";

type State = {
	tasks: ApiTaskMinimal[];
	status: ApiStatus;
	actions: ApiActions;
	api: AxiosInstance;
	pagination: Pagination;
	filter: ApiFilter;
};

const tasksAtom: any = atom(emptyApiState);

type Options = {
	filter?: any;
};

function useTasks(options?: Options): State {
	const auth = useAuth();
	const { state, actions, api, pagination } = useApi(tasksAtom, {
		baseUrl: `/${auth.type}/tasks`,
		query: {
			recent: 1,
			...(options?.filter || {}),
		},
	});

	return {
		tasks: state?.list || [],
		status: state.status,
		filter: state?.filter || null,
		pagination,
		actions,
		api,
	};
}

export default useTasks;
